import { defineField, defineType } from 'sanity'
import SingleProduct from '../../components/SingleProduct'

export default defineType({
  title: 'Custom add to cart',
  name: 'customAddToCart',
  description:
    'This block allows adding specific products to cart in dynamic pages',
  type: 'object',
  fields: [
    defineField({
      title: 'Title',
      name: 'title',
      type: 'string',
    }),
    defineField({
      title: 'Content',
      name: 'content',
      type: 'array',
      of: [
        {
          type: 'block',
          styles: [],
          lists: [],
          marks: {
            decorators: [
              { title: 'Strong', value: 'strong' },
              { title: 'Emphasis', value: 'em' },
            ],
          },
        },
      ],
    }),
    defineField({
      name: 'product',
      title: 'Product',
      type: 'object',
      description: 'Select (simple) product from Magento',
      fields: [
        defineField({
          name: 'id',
          type: 'number',
        }),
        defineField({
          name: 'sku',
          type: 'string',
        }),
        defineField({
          name: 'name',
          type: 'string',
        }),
      ],
      components: {
        input: SingleProduct,
      },
      validation: (rule) =>
        rule.required().custom((requiredProduct) => {
          if (!requiredProduct?.id) {
            return 'Required product id is required'
          }
          if (!requiredProduct?.sku) {
            return 'Required product sku is required'
          }
          if (!requiredProduct?.name) {
            return 'Required product name is required'
          }
          return true
        }),
    }),
    defineField({
      title: 'Cart warning',
      name: 'cartWarning',
      type: 'object',
      description: 'Display a custom warning label in the cart for this item',
      fields: [
        defineField({
          name: 'label',
          type: 'string',
        }),
        defineField({
          name: 'value',
          type: 'string',
        }),
      ],
      validation: (rule) =>
        rule.custom((cartWarning) => {
          if (!cartWarning) {
            return true
          }
          if (!cartWarning?.label) {
            return 'Cart warning label is required'
          }
          if (!cartWarning?.value) {
            return 'Cart warning value is required'
          }
          return true
        }),
    }),
  ],
  preview: {
    select: {
      title: 'title',
    },
    prepare({ title: t }) {
      const title = t || 'Custom Add To Cart'
      const subtitle = !t ? '' : 'Custom Add To Cart'
      return {
        title,
        subtitle,
      }
    },
  },
})